import React from 'react';
import { Form, Icon, Input, Radio, Select } from 'antd';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>Consent Process - REGAINED CAPACITY CONSENT FORM</h4>

          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_patient_regained_capacity ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> :
          <div style={{textAlign: 'justify'}}>
            <h3 align="center">
              INFORMATION AND CONSENT FORM
              <br/>
              (Subject Deferred Consent Form)
            </h3>
            <h3><u>TITLE:</u></h3>
            <p>Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial</p>

            <h3><u>SPONSOR-INVESTIGATOR:</u></h3>
            <p><b>Dr. Bijoy Menon, University of Calgary.</b></p>
            <p>Funded by Canadian Institutes of Health Research (CIHR)</p>

            <h3><u>SITE INVESTIGATOR:</u></h3>
            <p><b> Dr. Aleksander Tkach, Kelowna General Hospital</b></p>
            <p>Cell# 1-250-800-1196, email: Aleksander.Tkach@interiorhealth.ca</p>

            <p>This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information.</p>

            <h3>PURPOSE</h3>
            <p><i>If you, being the family member or partner, are acting as a representative to give consent for another person to participate in this study, “you” throughout this consent form refers to that individual (the subject).  Your obligation is to try to determine what the individual would do if competent, or if the subject’s wishes cannot be determined, what you think is in the person’s best interest.</i></p>

            <p><b>Your continued participation is voluntary</b></p>

            <p>Your continued participation is entirely voluntary and will not in any way affect the support or treatment you receive as a patient of the Interior Health physician or at the Kelowna General Hospital. You have the right to refuse to participate in this study. If you decide to participate, you may still choose to withdraw from the study at any time without any negative consequences to the medical care, education, or other services to which you are entitled or are presently receiving as a patient of Interior Health physicians or at the Kelowna General Hospital.</p>

            <p>You are being asked to take part in this study because you have had an acute ischemic stroke. This happens when a clot blocks a blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the brain can be damaged, sometimes permanently.</p>

            <p>We know that a medication called Alteplase (tPA) can reduce brain damage from a stroke by dissolving the clot in the blocked artery. This helps to restore normal blood supply to the brain before it becomes permanently damaged. Alteplase is the usual treatment for stroke patients. Despite the benefits of Alteplase at reducing brain damage and disability in stroke patients, there are risks including brain bleeding. Tenecteplase (TnK) is a different clot-dissolving medication that is similar to Alteplase, and is often used for patients who have a heart attack, where there is a clot blocking a blood vessel in the heart.  Tenecteplase is not currently approved for use in acute stroke care, but has shown very promising results in recent stroke studies.</p>

            <p>The aim of this study is to compare Alteplase with Tenecteplase for stroke treatment to determine if patients who receive Tenecteplase do as well as those who receive Alteplase, when followed out to 3 months after their stroke.</p>

            <p>Because a stroke is an emergency situation where every minute counts, and you may have been incapacitated at the time of your stroke, you were enrolled by deferral of consent, meaning that you received either Alteplase or Tenecteplase without first being asked. This process was designed in consultation with experts in research ethics and with stroke patients.</p>

            <p>If you consent to participate in this study, regular standard of care assessments will be performed, including routine follow up with your physician. A follow up visit at 3 months (roughly 90 days), would happen as in routine practice. An important part of this study is to see how patients have recovered and are functioning at 3 months after their stroke.  This assessment will be done through a telephone interview with research staff from the University of Calgary/Foothills Medical Centre.  The interview will last about 5 minutes. You will be called one time at 3 months (as close to 90 days as possible, to a maximum of 120 days depending on your schedule).</p>

            <p>For participants who are not fluent in English, the services of an interpreter will be offered so as not to exclude anyone on the basis of language. After the 3-month assessment by phone is finished, your participation in the study will be complete.</p>

            <p>It is anticipated that approximately 50-75 participants will be enrolled at Kelowna General Hospital.</p>

            <h3>RISKS AND DISCOMFORTS</h3>
            <p>All medical procedures involve some risk of injury. There may be risks associated with this study that are unknown and cannot be predicted, though all precautions will be taken to avoid this. Risks associated with standard care procedures such as CT and MRI scans, will be discussed by your physician.</p>

            <p>As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks are:</p>

            <p>
              1. Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.
              <br/>
              2. Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require specific treatment (such as surgery) or a blood transfusion.
              <br/>
              3. Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS) registry; this is the major side effect. The effects of bleeding into the brain may cause no symptoms at all, worsening of neurological symptoms, permanent disability, or death.
              <br/>
              4. Very rarely, Alteplase or Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead to low blood pressure, airway swelling and obstruction. This could potentially be fatal, but there have been no deaths reported due to allergy with either drug. This reaction can be treated with medication.
              <br/>
              5. The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in this study after consultation with an expert stroke physician.
              <br/>
              6. Baseline and 24-hour CT scans are part of standard stroke patient care and involve exposure of only a small amount of radiation in addition to the usual x-rays studies done in stroke patients.
            </p>

            <h3>POSSIBLE BENEFITS</h3>
            <p>If you agree to participate in this study, there may or may not be a direct medical benefit to you. Your participation will provide information about the study treatment(s) and stroke that may benefit others by helping to provide better future treatments for patients with stroke. Your stroke may be improved during the study but there is no guarantee of that. The possible benefits to you from taking part in this study are close monitoring of your stroke, general health status, and any symptoms that you may experience during the study.</p>

            <h3>NEW FINDINGS</h3>
            <p>You will receive any new information during the course of the study concerning significant treatment findings that may affect your willingness to continue your participation.</p>

            <h3>CONFIDENTIALITY</h3>
            <p>During the study we will be collecting health data about you. We will do everything we can to make sure that this data is kept private. Sometimes, by law, we may have to release your information with your name so we cannot guarantee absolute privacy. However, we will make every legal effort to make sure that your health information is kept private. The AcT Coordinating Centre at the University of Calgary is the main Canadian study site running this trial.</p>

            <p>No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.  Your name, telephone number and/or email will be provided to the AcT Coordinating Centre located at the University of Calgary, to contact you for conducting the telephone assessment required as part of this study. Every effort will be made to ensure that all parties who receive your private information understand the need to keep this information confidential.</p>

            <p>During research studies, it is important that the data we get is accurate and ensure the study is carried out correctly. Authorized representatives from the University of Calgary and the Interior Health Research Ethics Board, Health Canada and / or other regulatory agencies may look at your identifiable medical/clinical study records, including this consent form, in confidence and only for purposes of quality assurance.</p>

            <p>By signing the consent form, you are giving permission for the study doctor/staff to collect, use and disclose information about you from a number of sources.  Any health information that we get from any of these records will be limited to only what is needed for the study. These possible sources include your personal hospital chart, electronic medical records, including CareConnect, the OPTIMISE registry, your hospital site, other health care providers that you may have seen in the past (i.e. your family doctor) or the Canadian Institute for Health Information (CIHI) databases. The OPTIMISE Registry is a database that Canadian stroke centres use to enter information regarding stroke patients who receive thrombolysis to dissolve the clot causing their stroke, or endovascular treatment to remove the clot. CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital, how long they stayed, what types of doctors they saw, and other information about these hospitalizations/emergency department (ED) visits.  This information is stored in the CIHI clinical administrative databases, along with your health care number.  Your name is not included in the OPTIMISE or CIHI databases.</p>

            <p>In order to locate information about your past and future hospitalizations or ED visits up until a year after enrolment, which may include hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose of extracting your hospitalization records from its databases. CIHI will then provide these records back to the study investigators without the health care number, using a coded study identification number. The study investigators will add the CIHI data to the study data based on this study identification number.</p>

            <p>The signed consent form will be encrypted and electronically stored at the AcT Coordinating Centre located at the University of Calgary for review.</p>

            <p>After the study is done, we will still need to securely store your health data that was collected as part of the study. In Canada, the law says we have to keep the data stored for 25 years after the end of the study; after which the all the study data will be destroyed.</p>

            <p>A description of this clinical trial is available on http://www.ClinicalTrials.gov, and entering the AcT Study ID# NCT03889249, as encouraged by Health Canada. This Web site will not include any information that can identify you. At most, the Web site will include a summary of the results. You can search this Web site at any time.</p>

            <h3>COMPENSATION FOR INJURY</h3>
            <p>If you become ill or physically injured as a result of participation in this study, medical treatment will be provided at no additional cost to you. The costs of your medical treatment will be paid by your provincial medical plan. Financial compensation for such things as lost wages, disability or discomfort due to this type of injury is not routinely available.</p>

            <p>If you become ill or physically injured as a result of participating in this research, no compensation will be provided for you by the University of Calgary, Alberta Health Services, or the Researchers. You still have all your legal rights. Nothing said here about treatment or compensation in any way alters your right to recover damages.</p>

            <h3>CONSENT</h3>
            <p>You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.</p>

            <p>My signature on this consent form means:</p>

            <p>
              ▪ I have read and understood all 6 pages of this consent form.
              <br/>
              ▪ I understand that I have been enrolled in the research study.
              <br/>
              ▪ I have had enough time to think about the information provided.
              <br/>
              ▪ I have been able to ask for advice if needed.
              <br/>
              ▪ I have been able to ask questions and have had satisfactory responses to my questions.
              <br/>
              ▪ I understand that all of the information collected will be kept confidential and that the results will only     be used for scientific purposes.
              <br/>
              ▪ I understand that my participation in this study is voluntary.
              <br/>
              ▪ I understand that I am completely free at any time to refuse to participate or to withdraw from this study at any time, and that this will not change the quality of care that I receive.
              <br/>
              ▪ I authorize access to my health records as described in this consent form.
              <br/>
              ▪ I understand that I am not waiving any of my legal rights as a result of signing this consent form.
              <br/>
              ▪ I understand that there is no guarantee that this study will provide any benefits to me.
            </p>
          </div>}
        <p><strong>Server Date (UTC): {props.consentDate || props.date}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <p>Please check the appropriate box to indicate your decision:</p>
            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('kw_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

          </div>}

          <Form.Item>
            <label>
              <div className='form-label'>Participant Name</div>
              {props.form.getFieldDecorator('kw_consent_participant_name', {
                initialValue: props.kw_consent_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'EmailRegainedCapacity' && <Form.Item>
            {props.form.getFieldDecorator('kw_participant_email', {
              initialValue: props.kw_rccf_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
          </Form.Item>}

          <h4>SIGNATURES</h4>
          {showForEmail && <div>
            <p>Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a participant. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:</p>

            <p>
              Dr. Aleksander Tkach 250-800-1196 or
              <br/>
              Clinical Research Department 778-214-2065
            </p>

            <p>If you have any questions concerning your rights as a possible participant in this research, please contact the Interior Health Research Ethics Board Chair by calling 250-870-4602 or email researchethics@interiorhealth.ca.</p>

          </div>}

          {showForEmail && <div>
          <Form.Item>
            <label>
              <div className='form-label'>Name of Legally Authorized</div>
              {props.form.getFieldDecorator('kw_representative_name', {
                initialValue: props.kw_representative_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Name of Legally Authorized"
                />
              )}
            </label>
          </Form.Item>
          <Form.Item>
            <label>
              <div className='form-label'>Relationship to Participant</div>
              {props.form.getFieldDecorator('kw_representative_relationship_to_participant', {
                initialValue: props.kw_representative_relationship_to_participant,
                rules: [{
                  required: !props.token,
                  message: 'Required'
                }],
              })(
                <Input
                  placeholder="Relationship to Participant"
                />
              )}
            </label>
          </Form.Item>

          <Signature fieldName='kw_representative_signature' label='Signature of Legally Authorized' form={props.form} />
        </div>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Investigator/Delegate’s Name</div>
                {props.form.getFieldDecorator('kw_investigator_name', {
                  initialValue: props.kw_investigator_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Investigator/Delegate’s Name"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='kw_investigator_signature' label='Signature of Investigator' form={props.form} />}
          </div>

          <h4>Participant Consent for Continued Participation After a Legally Authorized Representative’s Consent was Obtained</h4>

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='kw_consent_participant_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Investigator/Delegate’s Name</div>
                {props.form.getFieldDecorator('kw_consent_investigator_name', {
                  initialValue: props.kw_consent_investigator_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Investigator/Delegate’s Name"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='kw_consent_investigator_signature' label='Signature of Investigator' form={props.form} />}
          </div>

          {showForEmail && <Form.Item>
            <label>
              <div className='form-label'>Do you consent to the terms described above?</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: 'Do you consent to the terms described above?'
                }],
              })(
                <Select>
                  <Option value="yes">Yes</Option>
                  <Option value="">No</Option>
                </Select>
              )}
            </label>
          </Form.Item>}

          <p>The Interior Health Research Ethics Board has approved this research study.  A signed copy of this consent form has been given to you to keep for your records and reference.</p>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeKelowna/Step3aRegainedCapacity.js